import {
  ApiTypes,
  MediaView,
  RightRequestView,
  CollectionView,
  CreatorView,
} from 'common';

export enum EPopup {
  getRights = 'getRights',
  account = 'account',
  settings = 'settings',
  userSettings = 'userSettings',
  rights = 'rights',
  collectOverlay = 'collectOverlay',
  setCreatorCountriesOverlay = 'setCreatorCountriesOverlay',
  notfound = 'notfound',
  promptconfirm = 'promptconfirm',
  widgetCreation = 'widgetCreation',
  downloadCollection = 'downloadCollection',
  addInfluencer = 'addInfluencer',
  editInfluencer = 'editInfluencer',
  addBlacklist = 'addBlacklist',
  crmSettings = 'crmSettings',
  crmAddTemplate = 'crmAddTemplate',
  templateSelector = 'templateSelector',
}

export type UserWithFeaturesView = ApiTypes.ResGetMe['user'];

export interface PopupsState {
  [EPopup.notfound]: null | boolean;
  [EPopup.account]: null | boolean;
  [EPopup.settings]: null | boolean;
  [EPopup.userSettings]: null | boolean;
  [EPopup.widgetCreation]: null | boolean;
  [EPopup.rights]: null | boolean;
  [EPopup.collectOverlay]: null | boolean;
  [EPopup.setCreatorCountriesOverlay]: null | boolean;
  [EPopup.getRights]:
    | null
    | {
        medias: MediaView[];
      }
    | {
        mediaId: string;
      };
  [EPopup.promptconfirm]: null | {
    question: string;
    answer: (yes: boolean) => Promise<any> | undefined | void;
    text?: {
      yes?: string;
      no?: string;
    };
    yesColor?: 'blue' | 'red';
  };
  [EPopup.downloadCollection]: null | string;
  [EPopup.addBlacklist]: null | boolean;
  [EPopup.addInfluencer]: null | boolean;
  [EPopup.editInfluencer]: null | CreatorView;
  [EPopup.crmSettings]: null | boolean;
  [EPopup.crmAddTemplate]: null | boolean;
  [EPopup.templateSelector]:
    | null
    | boolean
    | {
        filterType?: 'RR' | 'DM';
        selectedTemplateId?: string;
      };
}

export interface IDetailedMediaView {
  mediaId: string;
  collection?: CollectionView;
  uncollect: boolean;
  canEdit: boolean;
  rightsRequestStatus?: RightRequestView['status'] | 'none';
  onRightsRequestClick?: (status: string) => void;
  displayRightsRequestButton?: boolean;
  tab?: DetailedMediaViewTab;
}

export interface WindowSize {
  height: number;
  width: number;
}

export const detailedMediaViewTabs = ['info', 'product', 'similars'] as const;
export type DetailedMediaViewTab = (typeof detailedMediaViewTabs)[number];
